import { render, staticRenderFns } from "./StuCZManage.vue?vue&type=template&id=46bbaf32&scoped=true&"
import script from "./stuczmanage.js?vue&type=script&lang=js&"
export * from "./stuczmanage.js?vue&type=script&lang=js&"
import style0 from "./StuCZManage.vue?vue&type=style&index=0&id=46bbaf32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bbaf32",
  null
  
)

export default component.exports